import i18next from 'i18next';

i18next.addResources('en', 'DeleteChecklistModal', {
  title: 'Are you sure?',
  description: "You are now going to delete this checklist.\nThis action can't be undone.",
  confirm: 'Confirm',
  cancel: 'Cancel'
});
